var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 427.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: .75px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-6, .cls-10, .cls-7, .cls-8, .cls-9, .cls-11, .cls-12 {\n        fill: none;\n      }\n\n      .cls-1, .cls-8, .cls-12 {\n        stroke: #263238;\n      }\n\n      .cls-13 {\n        fill: #ebebeb;\n      }\n\n      .cls-14 {\n        fill: #f0f0f0;\n      }\n\n      .cls-15 {\n        fill: #ebb373;\n      }\n\n      .cls-16 {\n        fill: #e6e6e6;\n      }\n\n      .cls-17 {\n        fill: #f5f5f5;\n      }\n\n      .cls-18 {\n        fill: #e4873e;\n      }\n\n      .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-5, .cls-24, .cls-25 {\n        fill: #fff;\n      }\n\n      .cls-26 {\n        fill: #b97964;\n      }\n\n      .cls-27 {\n        fill: #a24e3f;\n      }\n\n      .cls-28 {\n        fill: #dc5753;\n      }\n\n      .cls-29 {\n        fill: #e0e0e0;\n      }\n\n      .cls-30 {\n        fill: #407bff;\n      }\n\n      .cls-31 {\n        fill: #263238;\n      }\n\n      .cls-2 {\n        opacity: .1;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-7 {\n        stroke: #000;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-11, .cls-12 {\n        stroke-width: .5px;\n      }\n\n      .cls-3, .cls-20, .cls-32, .cls-33 {\n        opacity: .2;\n      }\n\n      .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-34, .cls-33, .cls-35 {\n        isolation: isolate;\n      }\n\n      .cls-21 {\n        opacity: .8;\n      }\n\n      .cls-22, .cls-7 {\n        opacity: .6;\n      }\n\n      .cls-23, .cls-36 {\n        opacity: .4;\n      }\n\n      .cls-4 {\n        stroke-width: .25px;\n      }\n\n      .cls-4, .cls-37, .cls-34 {\n        opacity: .3;\n      }\n\n      .cls-5, .cls-9 {\n        stroke: #e0e0e0;\n      }\n\n      .cls-6, .cls-10, .cls-11 {\n        stroke: #407bff;\n      }\n\n      .cls-10, .cls-11, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-35 {\n        opacity: .5;\n      }\n\n      .cls-25 {\n        opacity: .7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_complete",
    "data-name": "Background complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m673.73,303.59h-180.75c-3.23,0-5.86-2.63-5.86-5.86V34.46c0-3.23,2.63-5.86,5.86-5.86h180.75c3.23,0,5.86,2.63,5.86,5.86v263.27c0,3.23-2.63,5.86-5.86,5.86ZM492.99,28.85c-3.09,0-5.61,2.52-5.61,5.61v263.27c0,3.09,2.52,5.61,5.61,5.61h180.75c3.09,0,5.61-2.52,5.61-5.61V34.46c0-3.09-2.52-5.61-5.61-5.61h-180.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m465.31,303.59h-180.75c-3.23,0-5.86-2.63-5.86-5.86V34.46c0-3.23,2.63-5.86,5.86-5.86h180.75c3.23,0,5.86,2.63,5.86,5.86v263.27c0,3.23-2.63,5.86-5.86,5.86ZM284.56,28.85c-3.09,0-5.61,2.52-5.61,5.61v263.27c0,3.09,2.52,5.61,5.61,5.61h180.75c3.09,0,5.61-2.52,5.61-5.61V34.46c0-3.09-2.52-5.61-5.61-5.61h-180.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m257.01,303.59H76.27c-3.23,0-5.86-2.63-5.86-5.86V34.46c0-3.23,2.63-5.86,5.86-5.86h180.75c3.23,0,5.86,2.63,5.86,5.86v263.27c0,3.23-2.63,5.86-5.86,5.86ZM76.27,28.85c-3.09,0-5.61,2.52-5.61,5.61v263.27c0,3.09,2.52,5.61,5.61,5.61h180.75c3.09,0,5.61-2.52,5.61-5.61V34.46c0-3.09-2.52-5.61-5.61-5.61H76.27Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    y: 364.66,
    width: 750,
    height: 0.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 653.63,
    y: 394.04,
    width: 55.73,
    height: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 495.04,
    y: 398.6,
    width: 14.63,
    height: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 40.64,
    y: 381.24,
    width: 72.67,
    height: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 128.3,
    y: 381.24,
    width: 10.66,
    height: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 173.59,
    y: 388.35,
    width: 157.61,
    height: 0.42
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m306.31,143.74c-1.64-.99-3.54-1.47-5.46-1.37-1.18-1.43-.23-3.57.91-5.02,1.14-1.45,2.53-3.11,2.1-4.9-.67-2.7-4.46-2.81-7.19-2.28-1.01-1.63-.98-3.66-1.47-5.54s-2.1-3.86-3.88-3.6c-1.79.26-2.89,2.24-4.65,2.66-2.05.48-3.83-1.33-5.43-2.69-.2-.17-.41-.33-.62-.47h0c.34-5.62,5.68-4.72,10.24-5.49,3.56-.59-5.88-9.59,1.32-12.49,1.39-.38,2.62-1.23,3.47-2.4.75-1.82.08-3.91-1.57-4.98-1.64-.99-3.53-1.46-5.44-1.37-1.18-1.43-.23-3.57.91-5.02s2.52-3.11,2.1-4.9c-.68-2.7-4.46-2.81-7.19-2.28-1.01-1.63-.98-3.66-1.47-5.54-.49-1.88-2.09-3.86-3.88-3.6-1.8.26-2.89,2.24-4.65,2.66-2.05.48-3.82-1.33-5.43-2.69-1.61-1.35-4.41-2.21-5.52-.42-.66,1.06-.26,2.54-.96,3.6-1.19,1.8-4.03.7-5.78-.6-1.75-1.3-4.58-2.47-5.78-.67-.31.59-.54,1.22-.68,1.87-.17.46-.41.9-.71,1.29-.35-1.25-.46-2.6-.78-3.86-.49-1.87-2.09-3.86-3.88-3.6-1.8.26-2.89,2.25-4.65,2.66-2.05.49-3.82-1.33-5.43-2.69s-4.41-2.21-5.52-.41c-.66,1.06-.26,2.54-.96,3.6-.14.24-.34.44-.58.59-.61-.12-1.21-.12-1.81-.12-1.18-1.41-.23-3.55.91-5.01,1.14-1.46,2.53-3.12,2.1-4.9-.67-2.71-4.46-2.81-7.19-2.28-1.01-1.64-.98-3.67-1.47-5.54-.49-1.87-2.09-3.87-3.89-3.6-1.8.28-2.89,2.25-4.65,2.67-2.05.48-3.82-1.32-5.43-2.69-1.61-1.37-4.41-2.21-5.52-.42-.66,1.04-.26,2.54-.96,3.6-1.19,1.79-4,.68-5.77-.61-1.76-1.29-4.59-2.47-5.79-.67-.31.59-.54,1.23-.68,1.88-.83,2.4-3.43,3.6-5.44,5.13-2.01,1.53-3.61,4.59-1.91,6.46.84.94,2.33,1.28,2.75,2.48.52,1.41-.98,2.79-2.18,3.81-1.57,1.74-2.03,4.22-1.2,6.41-.6.54-1.3.95-2.07,1.2-2.05.48-3.82-1.33-5.43-2.69-1.61-1.36-4.41-2.21-5.52-.42-.66,1.04-.26,2.54-.96,3.6-1.19,1.8-4,.7-5.77-.6-1.76-1.29-4.59-2.47-5.79-.67-.31.59-.54,1.22-.68,1.87-.83,2.4-3.43,3.6-5.44,5.13-2.01,1.53-3.61,4.59-1.91,6.48.8.94,2.19,1.32,2.67,2.4-1.41-.56-3.05-.42-3.7.64-.66,1.06-.26,2.54-.96,3.6-1.19,1.8-4,.7-5.77-.6-1.76-1.3-4.59-2.47-5.79-.67-.31.59-.54,1.23-.68,1.88-.83,2.4-3.43,3.57-5.44,5.12-2.01,1.55-3.61,4.6-1.91,6.47.84.92,2.33,1.28,2.75,2.48.53,1.41-.97,2.79-2.17,3.81-1.99,1.68-2.35,6.73.28,8.12,1.1.58,2.75.88,2.99,1.97.24,1.09-.86,1.93-1.59,2.77-.17.22-.32.45-.45.69-1.39,2.52-.47,5.68,2.05,7.07.64.29,1.4.54,1.64,1.2.09.49.04,1-.16,1.46-.25.92-.34,1.87-.25,2.82,0,.33.12.64.35.88.24.17.53.26.83.24,3.79.17,5.61-1.18,7.93,2.12.2.33.47.62.79.84.32.16.68.25,1.04.25,2.6.22,4.28-1.4,6.68-1.71,3.32-.42,4,1.28,6.92,2.65,4.57,2.16,6.79.83,7.65-2.29.23-.88.36-1.79.41-2.7-.02-1.37.56-2.69,1.59-3.6h.07c2.43.2,4.08-1.19,6.21-1.62l1.35-.14c2.53-.02,3.37,1.5,6,2.7,1.21.64,2.54.99,3.91,1.04.38,1.41-1.01,2.69-2.21,3.67-1.98,1.69-2.34,6.74.29,8.12,1.09.58,2.75.9,2.99,1.98s-.86,1.93-1.59,2.76c-.17.22-.32.44-.45.68-1.39,2.52-.48,5.69,2.04,7.09.62.3,1.4.54,1.63,1.2.1.49.05,1.01-.14,1.48-.26.91-.35,1.86-.25,2.81,0,.33.12.64.34.89.25.17.54.25.84.23,3.79.17,5.61-1.18,7.93,2.12.2.34.47.62.79.84.33.16.68.25,1.04.26,2.6.22,4.28-1.41,6.68-1.71,3.31-.42,4,1.28,6.91,2.65,4.58,2.15,6.8.83,7.66-2.29.23-.89.36-1.79.41-2.71.34-5.61,5.68-4.72,10.25-5.48.32-.03.61-.22.74-.52h.29c2.6.22,4.28-1.4,6.68-1.71,3.32-.42,4,1.28,6.92,2.65,4.57,2.16,6.79.83,7.65-2.29.23-.89.36-1.8.41-2.71.3-4.36,3.6-4.8,7.19-5.13.11,1.73,1.11,3.27,2.64,4.09.64.29,1.4.54,1.64,1.2.09.49.04,1-.16,1.46-.25.91-.34,1.86-.25,2.81,0,.33.12.64.34.89.25.16.54.25.84.24,3.79.17,5.61-1.18,7.93,2.12.2.33.47.62.79.84.32.16.68.25,1.04.25,2.6.22,4.28-1.4,6.68-1.71,3.32-.42,4,1.28,6.92,2.65,4.57,2.16,6.79.83,7.65-2.29.23-.88.36-1.79.41-2.7.34-5.62,5.7-4.72,10.25-5.49,3.56-.59-5.89-9.59,1.31-12.49,1.39-.38,2.62-1.23,3.47-2.4.66-1.74.06-3.71-1.46-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m173.87,177.25c-1.36-.83-2.95-1.23-4.54-1.14-.98-1.19-.18-2.97.76-4.19.94-1.22,2.11-2.54,1.74-4.09-.53-2.26-3.69-2.33-5.96-1.89-.85-1.37-.82-3.07-1.27-4.62-.44-1.55-1.65-3.17-3.24-2.98-1.59.19-2.41,1.88-3.88,2.22-1.7.41-3.18-1.1-4.52-2.23-1.33-1.13-3.68-1.84-4.61-.36-.55.89-.22,2.14-.79,3.02-1,1.52-3.35.57-4.82-.51-1.47-1.08-3.81-2.06-4.82-.56-.26.49-.45,1.02-.57,1.56-.69,2-2.84,2.99-4.53,4.28-1.69,1.28-3.02,3.81-1.59,5.39.7.77,1.93,1.09,2.28,2.07.43,1.27-.82,2.33-1.81,3.17-1.65,1.41-1.95,5.62.23,6.76.93.48,2.27.63,2.54,1.65.27,1.02-.71,1.61-1.27,2.31-1.47,1.89-1.12,4.62.77,6.09.18.14.37.26.56.37.52.25,1.17.46,1.36,1.02.09.43.05.87-.13,1.27-.21.76-.28,1.55-.2,2.33,0,.27.09.54.28.74.2.14.45.22.7.2,3.15.14,4.67-.98,6.6,1.76.17.28.39.51.66.7.27.14.57.21.88.22,2.17.18,3.58-1.17,5.57-1.42,2.74-.36,3.32,1.07,5.75,2.21,3.81,1.79,5.67.69,6.34-1.92.19-.74.3-1.49.34-2.25.28-4.68,4.75-3.95,8.54-4.58,2.97-.49-4.89-7.98,1.09-10.4,1.17-.32,2.19-1.03,2.89-2.02.64-1.53.08-3.31-1.33-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m231.89,151.38l4.89-15.51,9.52-12.24-1.63-1.36-8.98,9.79-1.6-15.51h-2.6s2.14,18.42-.94,25.17c0,0-11.16,28.4-17.96,34.54-.38.36-.72.76-1,1.21-2.04-5.23-4.69-10.19-7.89-14.8,2.68-6.87,8.44-21.95,10.4-30.03,1.53-6.27,2.68-12.63,3.44-19.04l-2.23-.24s-6.32,29.82-16.75,43.39c-3.09-2.84-6.6-5.2-10.4-6.98-.85-4.19-1.21-11.49,1.57-22.87l-2.21-.56s-4.21,9.63-3.84,21.2c-1.57-.79-3.08-1.69-4.53-2.68-10.06-7.07-17.13-19.86-17.13-19.86l-2.06,2s8.59,18.85,20.55,25.15c11.96,6.3,19.72,21.64,20.34,25.66.17,1.15,1.55,10.26-.36,26.22-12.73-5.43-37.96-20.39-39.63-21.76l-2.94,3.95,40.81,29.2c.64,38.92-2.3,79.41-2.19,88.17h23.77c-.59-12.08-5.59-57.53-3.37-105.02.19-1.17.39-2.5.58-4.06,1.86-14.57,12.91-34.47,18.17-40.13,5.64-6.07,11.9-10.87,11.9-10.87l-1.45-3.1-14.25,10.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m420.03,31.09c0-3.11-2.52-5.63-5.63-5.63h0c-.55,0-1.09.08-1.61.24.08-.57.12-1.15.12-1.73,0-6.58-5.34-11.92-11.92-11.92-.73,0-1.47.07-2.19.2-2.99-4.92-9.4-6.48-14.32-3.48-3.06,1.86-4.95,5.17-5,8.75h-.18c-5.3.17-9.47,4.61-9.3,9.91.16,5.06,4.23,9.13,9.3,9.3h35.26c3.05-.08,5.48-2.59,5.47-5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m510.58,87.01c0-2.88-2.34-5.22-5.22-5.22h0c-.51,0-1.01.07-1.49.22.07-.53.11-1.07.11-1.61,0-6.11-4.95-11.06-11.06-11.06-.68,0-1.36.06-2.03.19-2.78-4.56-8.72-6.01-13.28-3.23-2.84,1.73-4.59,4.8-4.64,8.12h-.17c-4.92.16-8.78,4.28-8.62,9.2.15,4.7,3.93,8.47,8.62,8.62h32.71c2.83-.08,5.09-2.4,5.07-5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m210.61,13.3c0-1.73-1.41-3.14-3.14-3.14h0c-.3,0-.61.04-.9.13.04-.32.07-.64.07-.96,0-3.67-2.98-6.65-6.65-6.65-.41,0-.82.04-1.22.11-1.67-2.74-5.24-3.61-7.99-1.94-1.71,1.04-2.76,2.88-2.79,4.88h-.1c-2.96.1-5.28,2.57-5.18,5.53.09,2.82,2.36,5.09,5.18,5.18h19.67c1.7-.05,3.06-1.44,3.05-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m666.97,30.84c0-3.02-2.45-5.47-5.47-5.47h0c-.53,0-1.06.08-1.57.23.08-.56.12-1.12.12-1.68,0-6.4-5.19-11.59-11.59-11.59-.71,0-1.43.07-2.13.19-2.91-4.78-9.14-6.3-13.92-3.39-2.98,1.81-4.81,5.03-4.86,8.51h-.17c-5.16.17-9.2,4.48-9.04,9.64.16,4.92,4.11,8.88,9.04,9.04h34.28c2.97-.08,5.33-2.51,5.32-5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m372.64,97.35c0-3.42-2.77-6.19-6.19-6.19h0c-.6,0-1.2.09-1.77.26.09-.63.13-1.27.13-1.9,0-7.24-5.87-13.1-13.1-13.1-.81,0-1.61.07-2.41.22-3.29-5.4-10.34-7.12-15.74-3.83-3.37,2.05-5.44,5.68-5.5,9.62h-.2c-5.83.19-10.41,5.07-10.22,10.9.18,5.57,4.65,10.04,10.22,10.22h38.76c3.36-.09,6.03-2.84,6.01-6.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlight--inject-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m612.92,303.27h6.45V73.04c-.01-11.57-9.38-20.94-20.95-20.95h-5.7v6.45h5.7c8,.01,14.49,6.49,14.5,14.5v230.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m551.43,59.99h46.44l-1.06-7c-.35-2.35-2.2-4.19-4.55-4.54-3.06-.45-7.07-1-8.95-1.03-5.48-.12-19.04,1.3-25.66,2.05-2.24.26-4.08,1.89-4.61,4.08l-1.61,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m556.34,64.89h36.63c2.71,0,4.9-2.2,4.9-4.9h-46.44c0,2.71,2.2,4.9,4.91,4.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 582.14,
    y1: 75.08,
    x2: 590.85,
    y2: 95.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m573.61,75.08c0,11.86-.73,21.73-.73,33.59"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 566.35,
    y1: 74.17,
    x2: 553.64,
    y2: 90.88
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m637.6,421.62c0,3.39-117.57,6.13-262.6,6.13s-262.6-2.75-262.6-6.13,117.57-6.13,262.6-6.13,262.6,2.75,262.6,6.13Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m61.88,43.77h98.63c7.25,0,13.14,5.89,13.14,13.14v211.26c0,9.4-7.63,17.03-17.03,17.03h-90.85c-9.4,0-17.03-7.63-17.03-17.03V56.91c0-7.25,5.89-13.14,13.14-13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m137.09,49.19l-2,3.95h-48.88l-2.91-3.95h-23.1c-3.7,0-6.69,2.96-6.69,6.61v212.97c0,5.52,4.53,9.99,10.11,9.99h95.15c5.59,0,10.11-4.47,10.11-9.99V55.8c0-3.65-3-6.61-6.69-6.61h-25.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 109.13,
    cy: 48.81,
    r: 2.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m114.11,48.81c0,.56-.45,1-1,1s-1.01-.45-1.01-1,.45-1,1.01-1,1,.45,1,1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m162.19,49.19h-25.1l-2,3.95h-48.88l-2.91-3.95h-23.1c-3.7,0-6.69,2.96-6.69,6.61v54.49h115.38v-54.49c0-3.65-3-6.61-6.69-6.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 72.05,
    y: 54.12,
    width: 1.53,
    height: 2.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 69.56,
    y: 53.44,
    width: 1.53,
    height: 2.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 67.08,
    y: 52.76,
    width: 1.53,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 64.6,
    y: 52.09,
    width: 1.53,
    height: 4.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 153.03,
    y: 53.38,
    width: 0.9,
    height: 2.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 154.55,
    y: 52.64,
    width: 7.2,
    height: 3.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 53.64,
    y: 101.17,
    width: 115.2,
    height: 170.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m168.84,127.41v-8.54l-27.09,24.98-28.62-9.53,17.93-33.16h-7.21l-7.64,14.12-55.45-14.12h-7.09v4.59l20.87,5.29-16.94,29.83,39.73,9.35-4.72,8.72-38.96-9.77v6.39l35.91,9-11.62,21.51-18.35-5.15-5.93,3.73v7.41l6.97-4.41,14.29,4.01-21.26,39.32v13.34l13.91-25.71,18.92,5.37v23.47l38.49,24.32h12.65l-44.73-28.2v-17.78l75.97,21.53v-6.44l-22.67-6.45,6.93-36.84,15.78,3.99v-6.38l-42.58-10.77,18.89-35.14,23.65-21.85Zm-101.63,9.35l13.72-24.07,32.26,8.22-12.8,23.66-33.18-7.81Zm79.64,59.23l-6.86,36.69-69.42-19.68,19.44-35.96,7.44,7.94,23.38,4.41,26.02,6.59Zm-27.01-13.06l-19.03-3.61-7.62-8.15,16.93-31.32,27.87,9.28-18.16,33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m148.84,91.64h-66.84c-2.37,0-4.3-1.92-4.31-4.29h0c0-2.38,1.92-4.31,4.3-4.31h66.85c2.37,0,4.29,1.94,4.28,4.31,0,0,0,.02,0,.02h0c-.02,2.35-1.93,4.25-4.28,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m72.47,84.3h0c-1.29-1.29-3.37-1.29-4.66,0h0c-1.26,1.28-1.26,3.34,0,4.62l2.31,2.31,2.31-2.31c1.27-1.27,1.29-3.33.04-4.62Zm-1.29,3.37c-.57.57-1.5.57-2.07,0-.57-.57-.57-1.5,0-2.07.57-.57,1.5-.57,2.07,0,.58.57.59,1.5.02,2.08,0,0-.01.01-.02.02v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m142.37,231.41c-2.4,0-4.34,1.88-4.34,4.19s1.94,4.19,4.34,4.19,4.34-1.88,4.34-4.19h0c0-2.32-1.94-4.19-4.34-4.19Zm0,6.92c-1.56,0-2.83-1.22-2.83-2.73s1.27-2.73,2.83-2.73,2.83,1.22,2.83,2.73h0c0,1.51-1.27,2.73-2.83,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m144.09,235.6c0,.92-.77,1.66-1.72,1.66s-1.72-.74-1.72-1.66.77-1.66,1.72-1.66,1.72.74,1.72,1.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m127.5,115.87l-9.14,17.06,23.4,6.93,12.91-12.9c-9.28-3.16-18.35-6.86-27.17-11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m168.84,101.16v11.65l-11.45,11.47c-7.7-2.65-15.3-5.51-22.7-8.82-1.88-.84-3.73-1.7-5.57-2.6l6.24-11.69h33.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "111.24 143.62 132.97 150.69 122.1 172.63 100.05 165.79 111.24 143.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m132.98,181.39c.18-.59,10.67-21.54,10.67-21.54l15.55,4.67,2.74,23.69-28.96-6.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "147.46 155.66 163.74 159.85 165.05 142.02 150.35 149.78 147.46 155.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m101.16,213.88c.33-.26,7.54-21.73,7.54-21.73l33.66,5.72-5.61,28.65-35.6-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m83.05,201.62l10.15,3.23-5.08,9.04s-10.69-2.36-10.69-3.06,5.61-9.2,5.61-9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m83.61,228.8c-.25.58-6.41,42.96-6.41,42.96h-23.55l.7-14.43,14.26-31.66,15.01,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m168.84,249.71v17.89l-25.74.98-22.38-16.09s3.85-10.7,5-14.1l43.12,11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m122.27,237.45l-19.33-5.08-2.74,9.17,17.49,9.14s4.58-12.35,4.58-13.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "168.84 213 168.84 232.54 151.05 228.8 154.67 210.3 168.84 213"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "62.4 175.56 68.04 163.12 83.75 167.58 77.43 180.58 62.4 175.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "76.71 132.27 84.46 118.73 105.47 124.62 98.42 139.08 76.71 132.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m118.7,101.16c-1.95,3.8-4.46,8.63-4.86,8.94-.4.31-26.38-6.04-37.87-8.94h42.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "68.03 114.76 53.64 143.78 53.64 111.15 68.03 114.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m144.09,230.56h-.16c-.49-.09-.82-.54-.74-1.01l6.25-34.85c-4.43-1.31-27.35-7.94-49.52-11.56-.2-.03-.38-.12-.52-.26l-10.54-11.04c-.26-.27-.32-.67-.15-1l12.23-22.73-38.72-8.45c-.49-.11-.8-.58-.69-1.06.02-.08.05-.16.09-.23l13.02-22.94c.25-.43.82-.58,1.26-.34.44.24.6.79.35,1.22l-12.48,21.92,38.69,8.45c.49.11.8.58.7,1.05-.02.08-.05.15-.08.22l-12.49,23.18,9.9,10.33c24.58,4.02,49.96,11.72,50.22,11.8.43.13.7.56.62.99l-6.36,35.57c-.07.42-.45.74-.9.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m79.61,104.02h0c-1.93-1.95-5.08-1.96-7.03-.03-.01,0-.02.02-.03.03h0c-1.92,1.94-1.92,5.06,0,7l3.5,3.5,3.5-3.5c1.93-1.92,1.96-5.04.06-7Zm-1.96,5.07c-.87.87-2.28.87-3.15,0-.87-.87-.87-2.28,0-3.15.87-.87,2.28-.87,3.15,0,0,0,0,0,0,0,.87.87.87,2.28,0,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m93.34,105.63h42.01c2.08,0,3.77,1.69,3.77,3.77v14.3c0,2.08-1.69,3.77-3.77,3.77h-42.02c-2.08,0-3.77-1.69-3.77-3.77v-14.3c0-2.08,1.69-3.77,3.77-3.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 101.19,
    cy: 113.2,
    r: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m101.19,116.56c-2.66,0-4.81,2.15-4.81,4.81h9.62c0-2.66-2.15-4.81-4.81-4.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m114.64,116.21c1.66,0,3.01-1.35,3.01-3.01s-1.35-3.01-3.01-3.01-3.01,1.35-3.01,3.01,1.35,3.01,3.01,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m114.64,116.56c-2.66,0-4.81,2.15-4.81,4.81h9.62c0-2.66-2.15-4.81-4.81-4.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 128.09,
    cy: 113.2,
    r: 3.01,
    transform: "translate(-25.51 188.22) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m128.09,116.56c-2.66,0-4.81,2.15-4.81,4.81h9.62c0-2.66-2.15-4.81-4.81-4.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m91.88,105.63h-8.62s7.22,5.8,7.39,5.8,1.24-5.8,1.24-5.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m83.61,271.75c-.74,0,5.84-14.12,5.8-14.4-.18-1.13,24.31,14.4,24.31,14.4h-30.11Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "GPS_Icon",
    "data-name": "GPS Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m372.66,74.54c14.93-14.37,38.68-13.92,53.06,1.01,13.99,14.53,13.99,37.51,0,52.04l-21.2,21.2c-2.94,2.94-7.71,2.94-10.66,0l-21.21-21.21c-14.64-14.65-14.64-38.39,0-53.04Zm26.54,43.96c9.89,0,17.86-8.25,17.4-18.24-.41-8.87-7.71-16.17-16.58-16.58-10-.46-18.24,7.51-18.24,17.4h0c.02,9.61,7.81,17.39,17.42,17.39v.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "435.8 109.37 596.07 109.37 596.07 146.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 596.07,
    cy: 144.15,
    r: 3.99
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_2",
    "data-name": "Speech Bubble 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 700.78,
    cy: 107.04,
    r: 20.09,
    transform: "translate(39.56 362.66) rotate(-29.82)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "687.34 115.39 682.2 114.81 680.08 120.98 686.49 120.66 687.34 115.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m717.1,89.13c5.3,3.81,8.47,10.42,8.11,16.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m724.95,109.06c.02,1-.17,2-.55,2.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m701.28,107.13c2.22,0,4.03-1.8,4.03-4.03s-1.8-4.03-4.03-4.03-4.03,1.8-4.03,4.03,1.8,4.03,4.03,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m701.28,107.6c-3.55,0-6.43,2.88-6.43,6.43h12.87c0-3.55-2.88-6.43-6.43-6.43Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_1",
    "data-name": "Speech Bubble 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 278.38,
    cy: 144.15,
    r: 20.09,
    transform: "translate(41.64 349.66) rotate(-68.34)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "286.27 157.78 284.88 162.76 290.64 165.83 291.34 159.45 286.27 157.78"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m294.71,126.25c5.3,3.81,8.47,10.42,8.11,16.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m302.55,146.18c.02,1-.17,2-.55,2.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 278.38,
    cy: 140.7,
    r: 4.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m278.38,145.2c-3.55,0-6.43,2.88-6.43,6.43h12.87c0-3.55-2.88-6.43-6.43-6.43Z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m705.8,363.34l9.85-7.75c6.28,7.15,11.34,14.27,15.17,18.52l-2.37,5.57-6.41-1.29s-6.81-7.3-16.23-15.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m715.23,373.61l3.83-2.44c3.92,1.98,4.7.4,5.18-3.12,1.03-.84,2.14.25,2.45.53l6.91,6.25c.58.52.64,1.41.12,1.99-.09.1-.2.19-.32.27-3.38,2.15-4.98,3.17-9.19,5.86l-12.87,8.2c-3.51,2.24-6.49-.84-5.25-2.09,5.59-5.58,8.97-10.42,9.77-13.59.16-.57-.38-.57-.63-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m714.66,376.99c1.04-.48,2.3-.47,3.34.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m713.76,379.4c1.04-.48,2.3-.47,3.34.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m712.31,381.87c1.04-.48,2.3-.47,3.34.02"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m733.72,376.82c-.09.1-.2.19-.32.27-3.38,2.15-4.98,3.17-9.19,5.86l-12.87,8.2c-1.9,1.21-3.64.86-4.64.09.54-.34,26.24-16.43,26.51-16.76l.5.47c.47.53.49,1.33.01,1.87Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m647.73,363.06l15.26,9.41c-1.13,11.45-3.95,21.85-2.89,27.47l-4.92,3.53-6.71-6.99s.58-20.48-.74-33.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m647.87,391.43l4.54-.1c2.32,3.73,3.81,2.78,6.05.02,1.31-.18,1.7,1.32,1.82,1.73l2.66,8.92c.23.75-.19,1.54-.93,1.77-.13.04-.27.06-.41.06-4.01.09-5.91.13-10.9.23l-15.26.32c-4.16.09-5.11-4.09-3.41-4.51,7.67-1.87,13.08-4.25,15.41-6.54.43-.4-.03-.69.43-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m645.63,394.02c1.14.13,2.21.79,2.84,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m643.61,395.61c1.14.13,2.21.79,2.84,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m641.08,396.96c1.14.13,2.21.79,2.84,1.75"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m662,403.77c-.13.04-.27.06-.41.06-4.01.09-5.91.13-10.9.23l-15.26.32c-2.25.05-3.55-1.15-4.01-2.33.63,0,30.96-.42,31.36-.56l.18.67c.13.7-.27,1.39-.96,1.61Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m668.35,144.45s-1.71-5.64.09-16.16c0-.01-.56-.19-.57-.2.25-1.47.53-2.84.81-4.02,0-.03,0-.05,0-.05l-12.96,10.19c.7,3.22.24,9.65-.16,12.39,0,0-1.22,5.01,5.21,4.5,4.7-.38,7.57-6.65,7.57-6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m656,138.82l7.82-2.72c-.45,2.58-2.32,5.78-7.87,6.66,0,0,.24-2.85.06-3.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m668.03,117.24c.06,8.94.27,13.98-3.92,18.82-6.31,7.27-17.34,4.03-20.08-4.74-2.46-7.89-2.15-21.19,6.35-25.25,8.37-4,17.59,2.23,17.65,11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m668.43,106.46c-1.56-4.82-13.86-4.04-17.12-1.3-.49.41,7.05,3.57,6.59,3.44l3.51.95c.52-.15,1.6.39,2.25,2,0,0,.54,13.68,4.68,17.37,3.01-1.73,2.82-7.15,3.58-10.44,1.13-4.9,2.41-12.05-3.49-12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m672.05,124.43c-.56,2.34-2.15,4.2-3.85,5.2-2.57,1.5-3.76-1.34-3.7-4.16.05-2.54.58-5.67,3.47-6.02,2.85-.34,4.71,2.3,4.08,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m655.46,120.68c.06.91-.37,1.68-.97,1.71-.6.03-1.13-.68-1.19-1.59-.06-.91.37-1.68.97-1.71.6-.03,1.13.68,1.19,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m646.53,121.47c.06.91-.37,1.68-.97,1.71-.6.03-1.13-.68-1.19-1.59-.06-.91.37-1.68.97-1.71.6-.03,1.13.68,1.19,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m649.41,120.76s-2.58,4.72-3.38,6.63c1.35,1.06,3.5.38,3.5.38l-.12-7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m657.39,116.23c-.13.07-.3.06-.43-.03-1.59-1.07-3.05-.49-3.06-.48-.22.09-.47-.01-.56-.23-.09-.22.01-.47.23-.56.08-.03,1.91-.76,3.88.57.2.13.25.4.12.59-.04.06-.1.11-.16.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m652.71,130.48c1.48-.09,2.58-.9,3.65-2.08"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m669.85,122.1c-.4-.51-1.14-.65-1.75-.46-.61.2-1.1.68-1.44,1.22-.41.65-.65,1.41-.69,2.18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m642.33,117.89c-.08-.01-.16-.05-.22-.11-.18-.16-.19-.43-.04-.6,1.56-1.77,3.51-1.47,3.6-1.47.23.04.39.26.36.49-.03.23-.25.39-.48.36-.08-.02-1.58-.22-2.84,1.19-.1.11-.24.16-.38.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m669.99,102.46c-.83-1.94-3.45-2.16-5.38-1.58-.11-2.44-3.4-3.58-5.39-3.34-2.07.24-2.75,1.14-2.75,1.14.16.02-.73-1.15-1.26-1.6-1.96-1.66-4.86-1.97-7.05-.74-2.19,1.22-3.55,3.91-3.3,6.52-1.4-1.2-3.71-.96-4.81.52-1.1,1.47-.79,3.9.65,5.05-1.52.22-2.65,1.94-2.33,3.53s2.03,2.71,3.51,2.32c.25,1.79.63,4.02.88,5.82l1.83-6.83c1.2-.55,1.39-1.13,1.52-2.51,1.06,1.62,2.47,1.36,4.31,1.13,1.84-.23,3.49-1.61,4.1-3.44,1.11,1.69,3.04,2.88,4.97,2.67,1.93-.21,3.64-2.07,3.46-4.11,1.29,1.64,3.76,2.09,5.46.99,1.7-1.1,2.42-3.6,1.58-5.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m683.53,143.89s7.95.22,11.15,9.09c2.94,8.17,10.43,26.18,10.43,26.18l-17.9,5.24-7.13-21.33,3.45-19.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m654.29,228.96l10.79,23.03s-17.14,51.59-18.17,56.97c-1.03,5.38-1.51,73.12-1.51,73.12l19.07.03,7.48-66.08s23.16-56.12,24.85-60.69c3.18-8.54-.16-20.02-.16-20.02l-5.9-8.5-36.46,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m643.81,240.51c0,2.1,7.44,73.55,8.66,73.81,1.22.26,55.11,59.2,55.11,59.2l15.3-13.44-39.54-53.61-4.38-48.18-1.53-30.29-34.49,2.55.87,9.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "669.97 332.96 670.92 316.18 682 291.63 682 291.63 673.68 317.58 672.89 335.35 669.97 332.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "649.99 298.03 665.08 251.99 659.82 247.19 661.49 253.79 649.33 292.56 649.99 298.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m597.83,166.26l23.35,21.43,10.88-20.26s11.87,11.72,11.47,11.9c-.4.17-13.98,29.89-23.77,24.56-9.79-5.33-26.34-32.15-26.34-32.15l4.41-5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m621.18,187.69s2.02,3.24,1.77,6.29c0,0,.91-1.5.63-3.93-.27-2.43-1.46-4.12-1.46-4.12l-.94,1.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m642.67,149.21c6.37,3.27,8.93,14.89-4.77,42.9l-16.36-12.62c2.62-6.99,5.29-10.63,9.48-19.11,6.65-13.17,11.65-11.17,11.65-11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m642.47,148.78c4.5-1,22.38-5.68,41.5-4.88l10.1,71.24s1.96,9.33,4.65,18.59c-18.21,10.55-43.49,12.25-57.06,6.49.18.28-.25-7.61-.83-19.17-1.03-20.38-2.54-52.15-2.07-70.7.02-.46,3.25-1.49,3.7-1.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "639.39 189.01 638.75 165.97 635.84 190.51 637.91 192.11 639.39 189.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "688.21 184.11 687.21 184.4 680.69 166.93 685.58 186.92 688.91 186.94 688.21 184.11"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m600.08,169.98s1.79-2.83,1.15-5.52c-.64-2.69-.43-5.02-1.05-6.99-.61-1.97-1.73.58-2.04,2.06-.32,1.48-.69,3.15-1.76,2.73-1.07-.42-7.28-8.12-8.83-8.53-1.55-.41-.94,1.15-.94,1.15,0,0-1.56-1.83-2.45-1.41-.23.11-.59.74-.01,1.68,1.3,2.13,4.27,6.45,4.27,6.45-.17-.25-4.21-5.32-4.91-6-.92-.89-1.81-.84-2.31-.29-.71.78,4.09,7.24,4.1,7.66,0,0-2.64-3.81-3.99-3.67-1.36.14.17,2.63,1.94,4.57,1.62,1.78,4.33,5.69,6.15,7.34,2.24,2.03,4.21,2.89,6.81,1.76,2.6-1.13,3.88-2.99,3.88-2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m586.86,155.08c1.21,1.5,2.36,3.05,3.43,4.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m586.27,164.48c1.46-2.02,3.52-3.6,5.85-4.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m596.07,163.46c-.68.75-1.1,1.74-1.15,2.75-.05,1.01.26,2.04.87,2.85"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m703.77,179.55s5.39,12.76,7.67,24.21c1.04,5.2-3.12,8.54-7.37,9.57-13.4,3.24-43.6,3.25-43.6,3.25l-.79-9.21,34.78-7.53-6.25-15.73,15.56-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m660.4,218.54l-11.4,1.29c-.39.04-.78-.09-1.06-.37l-17.35-17.15c-.72-.71-.39-1.93.59-2.18l10.03-2.59c.44-.11.91.01,1.23.33l18.73,18.45c.78.77.32,2.09-.76,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m661.46,207.42s-.32-1.34-5.37-2.88c-3.83-1.17-7.64-4.76-8.26-4.63s-1.3,2.08.3,3.8c1.59,1.73,3.24,2.7,2.82,3.36-1.01,1.59-13.48.3-13.7,1.66-.21,1.36,2.16,5.26,8.84,7.86,6.68,2.6,15.83,0,15.83,0l-.47-9.15Z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "598.54 359.04 72.69 371.36 72.69 281.42 603.6 281.42 598.54 359.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "598.54 359.04 72.69 371.36 72.69 281.42 603.6 281.42 598.54 359.04"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m52.46,304.5v45.61c0,9.77,6.36,18.4,15.7,21.28l3.72,1.13c2.29.71,4.68,1.04,7.07.98l24.56-.57c-2.92-10.21-3.17-20.99-.75-31.33,7.86-33.45,41.35-54.2,74.8-46.34,33.45,7.86,54.2,41.35,46.34,74.8l249.9-5.94c-.4-2.92-.6-5.86-.59-8.81.15-34.36,28.13-62.09,62.49-61.94,34.36.15,62.09,28.13,61.94,62.49,0,1.21-.1,2.41-.1,3.6.33-.13.67-.26,1-.43l8.55-3.81c8.43-3.81,13.85-12.2,13.85-21.45v-92.9c0-8.74-4.84-16.76-12.57-20.83l-64.23-33.78c-.74-.39-1.3-1.04-1.59-1.82-.65-1.76.26-3.7,2.01-4.35l7.86-2.82c.66-.23,1.13-.81,1.22-1.5.13-1-.58-1.92-1.58-2.05-30.52-4.26-149.22-19.78-211.62-12.15-71.97,8.81-140.95,71.27-140.95,71.27-52.97-1.98-102.41,16.45-123.7,25.71-6.87,3-12.16,8.76-14.56,15.87l-7.29,21.58c-.95,2.73-1.46,5.6-1.49,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m473.87,364.13c-.36-2.74-.54-5.5-.54-8.27,0-1.41.05-2.8.13-4.19l-45.19-18.48c-2.65-1.08-5.5-1.54-8.35-1.36l-157.18,10.31c-2.57.16-5.08.85-7.37,2.03l-29.86,15.36c-.21,3.55-.72,7.08-1.52,10.54l249.88-5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m620.96,333.77v-2.37l-25.56,7.83c1.49,5.42,2.24,11.01,2.24,16.63,0,1.21-.1,2.41-.1,3.6.33-.13.67-.26,1-.43l8.56-3.81c8.43-3.81,13.85-12.2,13.85-21.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m59.72,366.49c2.44,2.26,5.35,3.93,8.53,4.91l3.72,1.13c2.29.71,4.68,1.04,7.07.98l24.56-.57c-.89-3.1-1.53-6.27-1.92-9.48l-41.96,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m535.59,287.8c-2.82,0-5.65.17-8.45.52-37.29,4.66-63.75,38.66-59.09,75.95l5.89-.15c-.4-2.92-.6-5.86-.59-8.81.15-34.36,28.13-62.09,62.49-61.94,34.36.15,62.09,28.13,61.94,62.49,0,1.21-.1,2.41-.1,3.6.33-.13.67-.26,1-.43l4.91-2.23v-.95c-.05-37.58-30.5-68.03-68.08-68.06h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m163.42,287.8c-5.81,0-11.6.74-17.23,2.21-36.37,9.5-58.15,46.69-48.64,83.06l6.04-.13c-2.92-10.21-3.17-20.99-.75-31.33,7.86-33.45,41.35-54.2,74.8-46.34,33.45,7.86,54.2,41.35,46.34,74.8l6.03-.15c.98-4.63,1.47-9.36,1.47-14.1,0-37.58-30.48-68.04-68.06-68.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m222.65,235.47c-.73.62-1.24,1.5-1.46,2.5-.52,2.37.75,4.77,2.83,5.34l25.98,7.28c2.3.65,4.69.83,7.05.53l192.61-23.86c4.69-.6,9.06-3.02,12.37-6.86l25.27-29.44c.84-.97,1.37-2.24,1.51-3.59.34-3.35-1.76-6.37-4.69-6.75-46.12-6.12-104.44-11.68-141.26-7.18-48.26,5.89-96.85,42.17-120.2,62.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m223.52,235.47c-.73.62-1.24,1.5-1.46,2.5-.52,2.37.75,4.77,2.83,5.34l25.98,7.28c2.3.65,4.69.83,7.05.53l188.3-12.91c4.69-.6,11.93-9.21,17.06-16.2l24.89-31.05c.84-.97,1.37-2.24,1.51-3.59.34-3.35-1.76-6.37-4.69-6.75-46.12-6.12-104.44-11.68-141.26-7.18-48.26,5.89-96.85,42.17-120.2,62.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m349.34,253.82c-1.23-.44-1.87-1.8-1.43-3.04h0c.55-1.53,1.96-2.57,3.59-2.64l22.92-.97c.31-.01.62.03.91.14,1.24.44,1.89,1.81,1.45,3.06h0c-.56,1.53-1.98,2.57-3.6,2.64l-22.92.95c-.31.01-.62-.03-.91-.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m519.8,188.15c-2.03,1.8-2.21,4.91-.41,6.93l5.44,5.91c.62.66,1.42,1.14,2.29,1.39l66.59,18.47c1.16.31,2.35.47,3.55.47h13.23c-.69-.46-1.39-.88-2.13-1.28l-64.23-33.81s0,0,0,0c-1.62-.8-2.29-2.76-1.49-4.39l-20.86,5.22c-.74.2-1.41.57-1.98,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m105.16,267.25l-22.72-2.47-13.05,5.34c-2.74,1.12-4.79,3.48-5.53,6.35h0c-.43,1.66-.19,3.43.67,4.91l.23.39c1.46,2.51,4.29,3.9,7.17,3.5l13.1-1.8c1.28-.18,2.49-.68,3.52-1.46l15.11-11.46,1.5-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m199.54,232.82l3.62,1.03c2.81.8,5.84.15,8.07-1.74,21.06-17.81,57.66-45.14,97.17-57.88.18-.06.32-.18.41-.34.2-.35.07-.8-.28-1l-4.91-2.52c-56.99,19.76-104.08,62.45-104.08,62.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m199.54,232.82l3.62,1.03c2.81.8,5.84.15,8.07-1.74,21.06-17.81,57.66-45.14,97.17-57.88.18-.06.32-.18.41-.34.2-.35.07-.8-.28-1l-4.91-2.52c-56.99,19.76-104.08,62.45-104.08,62.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m415.46,256.87l-191.48,13.69,3.6,23.62c1.1,7.23,3.79,14.14,7.86,20.22l16,23.92,163.43-22.1,77.26-59.35h-76.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 535.53,
    cy: 355.86,
    r: 51.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 535.53,
    cy: 355.86,
    r: 31.78
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 532.99,
    y: 327.27,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    ry: 2.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 532.99,
    y: 363.08,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    ry: 2.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m545.24,353.19c-1.22.69-2.77.27-3.46-.95h0s0,0,0,0c-.7-1.22-.28-2.77.94-3.46l14.1-8.19c1.22-.7,2.78-.29,3.49.93h0c.69,1.22.28,2.77-.93,3.47l-14.1,8.19s-.02.01-.03.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m514.23,371.03c-1.22.7-2.77.28-3.46-.94h0s0,0,0,0c-.7-1.22-.28-2.77.94-3.46l14.1-8.19s0,0,0,0c1.21-.7,2.76-.29,3.47.92h0c.71,1.22.3,2.78-.92,3.49l-14.11,8.19s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m556.81,371.09l-14.1-8.19c-1.22-.71-1.64-2.27-.93-3.49h0c.71-1.21,2.27-1.62,3.49-.92l14.1,8.19c1.21.71,1.63,2.25.93,3.47h0c-.71,1.22-2.27,1.64-3.49.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m529.27,352.25c-.7,1.21-2.25,1.63-3.47.93l-14.1-8.19s0,0,0,0c-1.21-.7-1.63-2.25-.93-3.47h0s0,0,0,0c.7-1.21,2.25-1.63,3.47-.93l14.11,8.19s0,0,0,0c1.21.71,1.62,2.26.92,3.47h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m531.27,355.85c0-2.35,1.91-4.26,4.26-4.26h.02c2.36,0,4.27,1.91,4.27,4.27s-1.91,4.27-4.27,4.27-4.27-1.91-4.27-4.27v-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 163.42,
    cy: 355.86,
    r: 51.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 163.42,
    cy: 355.86,
    r: 31.78
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 160.87,
    y: 327.27,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    ry: 2.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 160.87,
    y: 363.08,
    width: 5.09,
    height: 21.37,
    rx: 2.54,
    ry: 2.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m173.11,353.2c-1.21.69-2.75.26-3.44-.95h0s0,0,0,0c-.7-1.21-.29-2.76.92-3.47l14.11-8.19s0,0,0,0c1.22-.7,2.77-.28,3.46.94h0s0,0,0,0c.7,1.22.28,2.77-.94,3.46l-14.1,8.19s-.02.01-.03.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m138.65,370.09h0s0,0,0,0c-.7-1.22-.28-2.77.94-3.46l14.1-8.19c1.22-.71,2.78-.3,3.49.92h0c.7,1.22.29,2.78-.93,3.49l-14.1,8.19c-1.22.7-2.78.29-3.49-.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m188.17,370.16c-.7,1.21-2.25,1.63-3.47.93l-14.11-8.19c-1.21-.71-1.62-2.27-.92-3.49h0s0,0,0,0c.71-1.21,2.26-1.62,3.47-.92l14.1,8.19s0,0,0,0c1.21.7,1.63,2.25.93,3.47h0s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m157.15,352.27c-.71,1.21-2.26,1.62-3.47.91l-14.1-8.19s0,0,0,0c-1.21-.7-1.63-2.25-.93-3.47h0c.71-1.22,2.27-1.64,3.49-.93l14.1,8.19s0,0,0,0c1.21.7,1.63,2.25.93,3.47h0s0,.02-.02.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m163.42,351.59h0c2.36,0,4.27,1.91,4.27,4.27s-1.91,4.27-4.27,4.27-4.27-1.91-4.27-4.27,1.91-4.27,4.27-4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m615.52,258.07c1.73-.54,2.69-2.37,2.15-4.1-.6-10.91-2.92-20.63-9.61-27.31-.45-1.47-1.86-2.43-3.39-2.31l-39.51,3.73c-.69.07-1.33.36-1.85.83-1.34,1.21-1.45,3.28-.23,4.63l11.31,12.2c.39.42.89.73,1.44.9l37.82,11.46c.61.17,1.25.16,1.86-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m221.19,237.95c-.52,2.37.75,4.77,2.83,5.34l25.98,7.28c2.3.65,4.23,1.1,7.22,1.23l8.18-.54-7.71-41.67c-17.82,11.7-19.04,12.23-35.03,25.85-.73.62-1.24,1.5-1.46,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m390.41,172.1l-16.32,71.16,21.35-1.53,9.75-68.96c-4.99-.29-9.92-.51-14.78-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m458.14,228.42l29.98-37.45c.86-.98,1.41-2.27,1.55-3.64.34-3.35-1.77-6.37-4.71-6.74-6.14-.83-12.68-1.64-19.22-2.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m244.81,245.19c-5.19.06-9.45-4.1-9.51-9.29h0c-.05-4.41,2.97-8.27,7.27-9.27l12.52-2.94,3.19,20.99-13.22.5c-.08,0-.17,0-.25,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "254.62 244.82 258.29 244.68 255.1 223.69 251.53 224.54 254.62 244.82"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m394.99,241.73c.15,7.38.07,15.18-.72,19.16-1.77,8.86-15.58,73.64-15.58,73.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m221.07,239.52s4.13,56.01,10.41,67.34c6.13,11.05,23.89,37.31,23.89,37.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m206.66,234.19s-44.15,10.91-57.14,12.99c-10.67,1.71-54.03,12.26-67.09,17.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m519.8,188.15c-2.03,1.8-2.21,4.91-.41,6.93l5.44,5.91c.62.66,1.42,1.14,2.29,1.39l66.59,18.47c1.16.31,2.35.47,3.55.47h13.23c-.69-.46-1.39-.88-2.13-1.28l-64.23-33.81s0,0,0,0c-1.62-.8-2.29-2.76-1.49-4.39l-20.86,5.22c-.74.2-1.41.57-1.98,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m269.71,230.7c-.6.36-7.67,7.67-7.67,7.67l1.38,9.06,8.89-9.18-2.6-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m280.36,249.6h0c-1.56.77-3.45.13-4.23-1.43l-14.1-28.58c-.77-1.56-.13-3.45,1.43-4.23h0c1.56-.77,3.45-.13,4.23,1.43l14.1,28.58c.77,1.56.13,3.45-1.43,4.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m295.75,215.2s7,27.91,11.1,28.97c7.43,1.91,33-.23,32.5-1.05l-1.09-12.84s-25.77,4.26-25.57,3.81l-9.71-21.7-7.23,2.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m302.18,214.07s2.3-2.14,2.36-4.73c.06-2.6.8-4.65.72-6.58-.09-1.93-1.7.12-2.34,1.38s-1.38,2.69-2.25,2.06c-.87-.63-4.67-9.1-5.98-9.84-1.31-.74-1.12.82-1.12.82,0,0-.98-2.03-1.89-1.86-.24.04-.72.53-.41,1.52.68,2.24,2.34,6.86,2.34,6.86-.09-.27-2.55-5.83-3.02-6.62-.62-1.03-1.44-1.19-2.02-.81-.83.54,1.98,7.54,1.89,7.92,0,0-1.48-4.08-2.75-4.28-1.26-.19-.47,2.43.67,4.61,1.04,2,2.57,6.19,3.83,8.12,1.55,2.38,3.13,3.62,5.76,3.22,2.63-.4,4.23-1.79,4.23-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m293.75,197.42c.74,1.65,1.41,3.33,2,5.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m290.97,205.8c1.8-1.48,4.05-2.42,6.37-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m300.09,207.21c-.8.52-1.41,1.32-1.7,2.22-.29.91-.25,1.91.11,2.79"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m368.74,228.34c-4.68-6.18-12.11-5.56-16.94-4.71l-9.57,1.58c-.3.05-.6.12-.89.21l-2.18.68-20.46,6.55,4.94,13.1,6.68-.82-1.11,1.81,6.56-.42h0l35.81-1.87h0s0-7.27,0-7.27c0-3.17-.92-6.32-2.83-8.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m366.8,238.66s-4.49,30.11-7.67,33.3c-7.58,7.62-35.65-13.34-35.65-13.34l.87-8.09,24.24,10.04,4.54-25.57,13.67,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m370.49,236.6c-.22.74-2.16,21.75-2.16,21.75l-20.56-1.92s1.07-5.83,2.63-16.03c1.62-10.62,2.57-15.99,7.83-16.86,9.98-1.64,12.26,13.06,12.26,13.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m363.6,189.04c3.1,5.44,4.18,8.69,4.46,13.9.33,6.09.05,11.47-1.31,13.03-1.78,2.05-21.07,3.97-31.87,3.53-.39-.02-.72-3.45-.72-3.45,0,0-1.53,3.35-2.04,3.33-2.95-.13-4.84-.24-4.84-.24,0,0,2.44-5.03,5.44-23.18,1.46-8.86,10.38-12.4,15.63-13.07,8.75-1.11,15.24,6.14,15.24,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m337.91,206.16c-2.83-4.89-5.63-18.07,6.15-22.14,14.71-5.08,21.3,4.31,22.56,13.6,1.26,9.3-3.98,16.32-13.7,15.62-9.72-.7-13.06-3.7-15.01-7.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m358.33,206.82l-8.69,7.99-1.67,1.78c.46,1.26.85,2.55.98,3.79.26,2.19-1.09,3.84-1.09,3.84l-1.95,4.43c4.35-3.41,14.26-5.23,14.26-5.23-1.63-5.69-2.31-11.03-1.84-16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m349,220.87c2.35-1.25,4.96-3.48,4.78-6.18-.08-1.14-.28-2.22-.51-2.92l-4.92,5.92c.33,1.01.44,1.67.65,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m361.1,197.94c-1.18,8.49-1.5,12.1-6.1,16.37-6.93,6.42-17.01,3.69-18.38-4.85-1.23-7.68.91-20.28,9.45-23.48,8.41-3.15,16.21,3.46,15.03,11.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m350.26,200.53c-.09.86-.65,1.54-1.25,1.52-.6-.02-1.02-.72-.93-1.58.09-.86.65-1.54,1.25-1.52.6.02,1.02.72.94,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m341.4,199.96c-.09.82-.64,1.47-1.23,1.45-.59-.02-1.01-.69-.92-1.51.09-.82.64-1.47,1.23-1.45.59.01,1,.69.92,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m351.61,197.44c-.12.02-.24,0-.33-.08-1.46-1.15-3.06-.65-3.08-.64-.24.08-.48-.04-.54-.26-.06-.22.08-.46.32-.54.08-.03,2.09-.66,3.9.77.18.14.19.41.03.6-.08.09-.19.14-.3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m338.57,195.68c-.09-.05-.16-.13-.19-.23-.06-.21.07-.44.3-.51,2.3-.66,3.8.51,3.86.56.18.14.19.4.04.57-.16.17-.43.2-.61.05-.06-.05-1.24-.94-3.07-.41-.12.03-.24.02-.34-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m354.32,190.02c-2.85,2.72-2,13.55,5.56,15.31,8.87-1.66,2.94-23.44-5.56-15.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m343.28,208.04c.64,1.1,1.38,3.21,1.38,3.21.2-.03.41-.06.61-.11,2.75-.51,3.85-1.65,4.24-2.77.21-.61.2-1.22.13-1.7-.08-.56-.26-.94-.26-.94-1.29,1.14-3.82,1.81-5.18,2.11-.57.13-.93.19-.93.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m344.21,207.85l.43.94c2.58-.49,4.34-1.18,5-2.11-.08-.56-.26-.94-.26-.94-1.29,1.14-3.82,1.81-5.18,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m345.27,211.14c2.75-.51,3.85-1.65,4.24-2.77-.93.21-2.03.57-2.94,1.17-.7.46-1.08,1.04-1.31,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m343.82,199.48s-1.79,3.77-3.55,5.57c1.04,1.11,3.02.64,3.02.64l.53-6.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m347.64,198.47l1.94.55c-.93.96-1.94-.55-1.94-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m338.9,197.98l1.94.55c-.93.96-1.94-.55-1.94-.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m346.21,184.15c-3.42.99-7.27,6.65-7.97,8.87,4.75,1.01,17.87-2.88,17.87-2.88,0,0,8.51,2.78,4.34-1.79-4.16-4.57-14.25-4.19-14.25-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m363.36,205.01c-1.09,1.7-2.78,2.73-4.3,3.03-2.28.46-3.28-3.22-2.41-5.45.79-2,3.07-3.25,5.25-2.7,2.14.54,2.7,3.17,1.46,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m334.03,194.38c-.65,3.73-1.32,7.5-2.75,11.01-1.43,3.51-4.4,10.75-7.65,12.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m358.39,207.79c-.04.88.64,1.62,1.52,1.66.88.04,1.62-.64,1.66-1.52.04-.88-.64-1.62-1.52-1.66-.88-.04-1.62.64-1.66,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m361.68,202.49c-.74-.25-1.6-.13-2.25.3-.65.43-1.09,1.17-1.15,1.95"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m333.89,256.12l-9.54-5.6-2.6-3.33s-2.68-3.16-4.84-3.37c-1.54-.14-3.14.65-3.14.65,0,0-2.5,1.58-.97,3.96,0,0-2.48,1.28-.79,4.04,0,0-2.37.04-.35,2.52s4.42,2.97,6.32,3.26c1.9.29,4.19-.37,4.19-.37l10.53,6.92,1.18-8.69Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "349.58 245.63 351.3 234.85 346.05 245.76 349.58 245.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.32 244.94 334.61 236.22 326.37 245.42 330.32 244.94"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login-image.d81dce20c4e389e6cad5227db119578a.svg";
export { ForwardRef as ReactComponent };